import { request } from './client';
import { unwrapApiData } from '../utils/apiResponse';

/**
 * @param {{ content: string, contact?: string, pageUrl?: string }} body
 */
export function submitFeedback(body) {
  return unwrapApiData(request('/feedback', { method: 'POST', body }));
}
